export default {
  apiKey: 'AIzaSyAvIyjie2qgfpbaCZ3ojXTFQXQaU6GEhtI',
  authDomain: 'schule-formular.firebaseapp.com',
  projectId: 'schule-formular',
  appId: '1:968502165405:web:97b767ab0ecadbffb37974',
  measurementId: 'G-BFZ1F273W1',
};
